const Na = () => <span className='opacity-60'>n/a</span>;
export default Na;
